module.exports = __webpack_public_path__ + "static/media/yoga.796c4bc6.png";